import { FileApiServices } from "../../../../services/api/FileServiceClient";
import { getFileUrl, uploadFileWithSignedUrl } from "../../../../services/FilesService";
import store from "../../../../state/configureStore";
import webSocketClientApi from "../../../../services/socket/wsApiServices";

export const uploadingTheFile = async (
	file,
	conversationId,
	fileName,
	fileScope = null,
	scopeId
) => {

	const isOnline = store.getState().user.isOnline;
    const selectedDomain = store.getState().domain.selectedDomain;
	try {
		if (isOnline) {
			// await FileApiServices.uploadLargeFile({
			// 	file,
			// 	conversationId,
			// 	scopeId: scopeId || conversationId,
			// 	fileName,
			// 	fileScope,
			// });
			let payload = {
			"fileScope": "conversations",
			"fileName": conversationId + ".png",
			selectedDomain
		}
		webSocketClientApi.GetSignedUrlsForUpload(payload)
			.then((res) => {
				if (res?.signedThumbnailUrl) {
					uploadFileWithSignedUrl(res.signedThumbnailUrl, file);
				}
			})
			.catch((error) => {
				console.error("Error in uploading group image", error);
			
			})
		} else {
			// Uncomment and implement queueFileUpload when offline support is ready
			// await queueFileUpload({
			//   file,
			//   conversationId,
			//   scopeId: conversationId,
			//   fileName,
			//   fileScope,
			// });
		}
		const fileUrl = await getFileUrl(conversationId, fileName);
		
		return fileUrl;
	} catch (error) {
		console.error("Error on upload", error);
		throw error;
	}
}
